import React from "react";

import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import MenueItem from "./menue-item"; 
import { BaseMenu } from './base-menu';
import MenuItem from './menue-item';

class SearchMenu extends BaseMenu {
  constructor(props) {
    super(props, 'SEARCH_MENU');
  }

  render() {
    const { t } = this.props; 
    const show = this.status.show;

    let menue = null;
    menue = (
        <ul className="nav navbar-nav" onClick={this.toggleShow} onMouseOver={this.showMenu} >
          <li className="dropdown open">
            <a className="dropdown-toggle">{t("ES Search")}</a>
            {show && (
                <ul className="dropdown-menu">
                  <MenueItem title="videoGameSearch" to="/vgsearch" />
                  <MenueItem title="mealSearch" to="/mealsearch" />
                </ul>
            )}
          </li>
        </ul>
    );

    return menue;
  }
}

export default translate()(SearchMenu);
